module.exports = __webpack_public_path__ + "img/achievement-course3.2c87ca5e.png";